import React, { PureComponent } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';

class LeftNav extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        changePageInfo: PropTypes.func,
    };
    constructor(props) {
        super(props);

        this.state = {
            level1Expend: -1,
            level2Expend: -1,
            // preLevel1Expend: -1,
            // preLevel2Expend: -1,
        };
    }
    changeExpend = (level, item, index) => {
        const { level1Expend, level2Expend } = this.state;

        // 一级导航展开收起状态改变后二级导航全部收起
        if (level === 1) {
            this.setState({
                level2Expend: -1,
            });
            if (level1Expend === index) {
                this.setState({
                    level1Expend: -1,
                });
            } else {
                this.setState({
                    level1Expend: index,
                });
            }
        } else if (level2Expend === index) {
            this.setState({
                level2Expend: -1,
            });
        } else {
            this.setState({
                level2Expend: index,
            });
        }
    };
    render() {
        const { content, changePageInfo } = this.props;
        const { level1Expend, level2Expend } = this.state;

        return (
            <div className={styles.phtv_sidebar}>
                <h2>Phoenix TV</h2>
                <ul>
                    {content.map((li1, index1) => {
                        if (li1.url) {
                            return (
                                <li
                                    className={index1 === 0 ? styles.phtv_on : ''}
                                    key={index1}
                                    onClick={_ => {
                                        changePageInfo({ ...li1 });
                                    }}>
                                    <span className={styles.navItem}>{li1.title}</span>
                                </li>
                            );
                        } else {
                            return (
                                <li key={index1}>
                                    <span
                                        className={`${styles.phtv_arrow} ${styles.navItem} ${
                                            index1 === level1Expend ? styles.up : ''
                                        }`}
                                        onClick={this.changeExpend.bind(this, 1, li1, index1)}>
                                        {li1.title}
                                        <span />
                                    </span>
                                    <ul className={index1 === level1Expend ? '' : styles.hide}>
                                        {li1.child.map((li2, index2) => {
                                            if (!(li2.child && li2.child.length) && li2.url) {
                                                return (
                                                    <li
                                                        key={index2}
                                                        onClick={_ => {
                                                            changePageInfo({ ...li2 });
                                                        }}>
                                                        <span className={styles.navItem}>{li2.title}</span>
                                                    </li>
                                                );
                                            } else {
                                                return (
                                                    <li key={index2}>
                                                        <span
                                                            className={`${styles.phtv_arrow} ${styles.navItem} ${
                                                                index2 === level2Expend ? styles.up : ''
                                                            }`}
                                                            onClick={this.changeExpend.bind(this, 2, li2, index2)}>
                                                            {li2.title}
                                                            <span />
                                                        </span>
                                                        <ul className={index2 === level2Expend ? '' : styles.hide}>
                                                            {li2.child.map((li3, index3) => {
                                                                return (
                                                                    <li
                                                                        key={index3}
                                                                        onClick={_ => {
                                                                            changePageInfo({ ...li3 });
                                                                        }}>
                                                                        <span className={styles.navItem}>
                                                                            {li3.title}
                                                                        </span>
                                                                    </li>
                                                                );
                                                            })}
                                                        </ul>
                                                    </li>
                                                );
                                            }
                                        })}
                                    </ul>
                                </li>
                            );
                        }
                    })}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(LeftNav);
